/** The Spanish catalogue for what each marcadora is — the wording only. Why each entry exists is argued in `en/markers.ts`. */
export default {
  kriss: 'Subfusil compacto, culata plegable.',
  smg9: 'Subfusil con supresor y riel óptico.',
  m4: 'Carabina moderna, riel y óptica.',
  ak47: 'Fusil de asalto clásico, madera.',
  fn502: 'Pistola. Es la SECUNDARIA — se cambia con N.',
  snipper: 'Cerrojo con mira. Lo trae la R5.',
  side_now: 'Ahora mismo es la {marker}. Si te cambian de bando, cambia contigo.',
  side_any: 'La que el campo asigne a tu lado.',
};
